import React from 'react';
import styled, { css } from 'styled-components';
import { ASSET_KEY, assetSource } from 'shared/utils/assetSource';
import Button from '../../../components/Button/Button';
import { getText, TEXT_KEY } from 'shared/utils/localization';
import usePiggyBankUnlocked from 'shared/screens/PiggyBank/hooks/usePiggyBankUnlocked';

const PiggyBankUnlocked = props => {
  const { handlePiggyBankUnlocked, handleCloseModal, piggyBankAssets } = usePiggyBankUnlocked(props);

  return (
    <Container $source={piggyBankAssets?.PIGGY_BANK_TUTORIAL_POPUP}>
      <CloseButton src={piggyBankAssets.PIGGY_BANK_CLOSE_BUTTON} onClick={handleCloseModal} />
      <WrapperButton>
        <MainButton
          label={getText(TEXT_KEY.BATTLES_LEARN_MORE)}
          imageSource={assetSource(ASSET_KEY.ROUNDEDRECT_PRIMARY_WIDE)}
          onClick={handlePiggyBankUnlocked}
        />
      </WrapperButton>
    </Container>
  );
};

export default PiggyBankUnlocked;

PiggyBankUnlocked.hideDefaultBackground = true;
PiggyBankUnlocked.hideCloseButton = true;
PiggyBankUnlocked.AsModalProps = {
  dialogClassName: 'gtp-modal-piggy-bank gtp-modal-piggy-bank-unlocked',
};

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: url(${({ $source }) => $source});
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  z-index: -1;
`;

const CloseButton = styled.img`
  width: 3dvw;
  height: 3dvw;
  object-fit: contain;
  position: absolute;
  top: 5dvw;
  right: 20dvw;
  cursor: pointer;
  ${({ theme }) =>
    theme.screens.device('mobile-browser') &&
    `
      top: 8dvw;
      right: 24dvw;
  `}
`;

const WrapperButton = styled.div`
  position: absolute;
  bottom: 4vw;
  width: 25vw;
  display: flex;
  justify-content: center;
  ${({ theme }) =>
    theme.screens.device('mobile-browser') &&
    `
    bottom: 3.5dvw;
  `}
`;

const MainButton = styled(Button).attrs({
  containerStyle: css`
    position: relative;
    width: 100%;
  `,
  imageStyle: css`
    width: 100%;
  `,
  textStyle: css`
    font-size: 2vw;
    text-transform: uppercase;
  `,
})``;
